import { render, staticRenderFns } from "./AddThemeTemplate.vue?vue&type=template&id=68c12791&scoped=true"
import script from "./AddThemeTemplate.vue?vue&type=script&lang=js"
export * from "./AddThemeTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddThemeTemplate.vue?vue&type=style&index=0&id=68c12791&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c12791",
  null
  
)

export default component.exports